module.exports = __webpack_public_path__ + "c8fff21c045d75e96d24c83770321f7e.svg";